// extracted by mini-css-extract-plugin
module.exports = {"level":"_3O-ttPpKM5ejDeN3hsDi3R","score":"_1Mm3tKSL5z22leIYdi5Awg","item":"g1gtEIjC0AgNuhJMGl5WL","label":"_12mGW5T1UBqecJFVfnar13","value":"WL-gI2v09msPHthlZ263j"};